import * as React from 'react';
import { BuyToneDto, BuyToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/buytone/buytonedto';
import { SendOTPDto, SendOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { MsisdnFloatingTextComponent } from '../../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { MSISDNValidation } from '../../../toolkit/msisdnvalidation/msisdnvalidation';
import { UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { BuyToneComponentState } from '../buytone/buytonecomponent';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../confirmrequest/confirmrequestconfirmbuttoncss';
import { LoaderWrapperComponent } from '../loaderwrappercomponent';
import {  MSISDNValidationComponentHandler, MSISDNValidationComponentProps } from './msisdnvalidationcomponent';
import { MSISDNValidationCSSStyle } from './msisdnvalidationcss';

export class MSISDNValidationViewImpl extends UIComponentViewImpl<UIDataModel>
{

    private contactNumber:MsisdnFloatingTextComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;


    bindHandlers()
    {   
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
    }

    draw(props: MSISDNValidationComponentProps, state: UIComponentState, cssStyle: MSISDNValidationCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
            <div style={cssStyle.getHeaderDivCSSStyle()}>
                <label style={cssStyle.getTitleCSSStyle()}>{props.headerTitle}</label>
                <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
                    <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                </div>
                     
            </div>
            <div style={cssStyle.getMobileNumberCSSStyle()}>
                        <MsisdnFloatingTextComponent hint={props.context.getResources().getString(Strings.mobilenumberhint)} maxLength={props.context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => this.contactNumber = item} id={"#mobilenumber"} value={props.context.getUserContext().getMsisdn()} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.entercontactnumber)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/>
            </div>
            {/* <div style={{width:'100%',height:'20px',display:'flex',textAlign:'center',marginTop:'25px',marginLeft:'auto',marginRight:'auto'}}>
                 <label style={{width:'100%',height:'100%',lineHeight:'20px',color:'#003187',fontSize:'15px',fontWeight:300}}>
                     {"Resend OTP"}
                 </label>
            </div> */}
             <div style={{width:'100%',height:'40px',display:'flex',justifyContent:'center',marginTop:'50px',marginLeft:'auto',marginRight:'auto'}}>
                       
                        <div style={{width:'180px',height:'40px'}}>
                            <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.verify)}/>
                        </div>
                </div>
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </div>
        );
    }

    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

     
    validate(): boolean
    {

        if(this.contactNumber.validate())
        {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.contactNumber.getData());
            
            let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
            let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

           
            if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
            {
                this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                return false;
            }
          
            return true;   
        } 
        return false;    
    }

    getData(): BuyToneDto
    {
        let toneDto = (this.getUIProps() as MSISDNValidationComponentProps).toneDto;
        let request = new BuyToneDtoImpl();
        request.setToneId(toneDto.getId());
        request.setToneName(toneDto.getToneName());
        request.setLanguage(this.getUIProps().context.getUserContext().getLanguage());
        request.setMsisdn(this.contactNumber.getData());
        request.setUserName(this.getUIProps().context.getUserContext().getUsername());
        request.setChannel(this.getUIProps().context.getUserContext().getChannelId());
        request.setPackName("");

        return request;
    }
    getOTPData(): SendOTPDto
    {
        let request = new SendOTPDtoImpl();
        request.setMsisdn((this.getUIState() as BuyToneComponentState).msisdn);

        return request;
    }

    onConfirmClick():void{
        (this.getUIComponentHandler() as MSISDNValidationComponentHandler).onConfirmClick();

    }

    onCloseClick():void{
         (this.getUIComponentHandler() as MSISDNValidationComponentHandler).onClosePopup();
    }
  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/msisdnvalidation/msisdnvalidationview.tsx